const RESOURCE_NAME = '/trandata-dms';

export default axios => ({
	getAll(unitId, params) {
		let url = `${RESOURCE_NAME}`
		if (unitId > '') url = `/unit/${unitId}`+url
		return axios.get(url, {params});
	},
});